'use client'

import { AUTH_TOKEN_COOKIE } from 'constants/generalConstants'
import { atom } from 'jotai'
import { atomWithStorage } from 'jotai/utils'
import { isOnServer } from 'utils/generalUtils'

import { getStore } from '@/store'
import { deleteCookieClient, getCookieClient } from '@/utils/client'

import { setAuthCookies } from './utils/authCookies'

// Atom to store the access token
export const authTokenAtom = atomWithStorage<string | null>(
	'authToken',
	(!isOnServer && getCookieClient(AUTH_TOKEN_COOKIE)) || null,
)

export const pending2faAccessTokenAtom = atom<string | null>(null)

export const setAuthToken = (token: string | null, role?: string) => {
	getStore().set(authTokenAtom, token)
	if (token) {
		setAuthCookies(token, role)
	} else {
		deleteCookieClient(AUTH_TOKEN_COOKIE)
		deleteCookieClient('role')
	}
}

export const getAuthToken = (): string | null => {
	return getStore().get(authTokenAtom)
}
